import { useEffect } from "react";

const TAWK_SRC = "https://embed.tawk.to/6a52d8f09a72601d480b44a7/default";

const TawkTo = () => {
  useEffect(() => {
    if (document.getElementById("tawkto-script")) return;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];
    s1.id = "tawkto-script";
    s1.async = true;
    s1.src = TAWK_SRC;
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    if (s0 && s0.parentNode) {
      s0.parentNode.insertBefore(s1, s0);
    } else {
      document.head.appendChild(s1);
    }
  }, []);

  return null;
};

export default TawkTo;
